/**
 * modules/countdown.js
 * Gestion du compte à rebours pour la date de lancement
 */

/**
 * Initialise et gère le compte à rebours
 */
export function initCountdown() {
    const countDownDate = new Date("Apr 30, 2025 00:00:00").getTime();
    const countdownElement = document.getElementById("countdown");
  
    if (!countdownElement) return;
  
    const daysElement = document.getElementById("days");
    const hoursElement = document.getElementById("hours");
    const minutesElement = document.getElementById("minutes");
    const secondsElement = document.getElementById("seconds");
  
    function updateCountdown() {
      const now = new Date().getTime();
      const distance = countDownDate - now;
  
      if (distance < 0) {
        clearInterval(countdownInterval);
        countdownElement.innerHTML = "FamilyStory.live est maintenant disponible !";
        return;
      }
  
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      daysElement.innerHTML = String(days).padStart(2, "0");
      hoursElement.innerHTML = String(hours).padStart(2, "0");
      minutesElement.innerHTML = String(minutes).padStart(2, "0");
      secondsElement.innerHTML = String(seconds).padStart(2, "0");
    }
  
    // Mise à jour initiale et lancement du minuteur
    let countdownInterval;
    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }